module.exports = __webpack_public_path__ + "img/Servicio_inactivo.ea906a34.svg";